import { Platform } from 'react-native';

const NATIVE_APP_URL = 'https://www.repaschallenge.ch';
const WEB_APP_URL = process.env.EXPO_PUBLIC_WEB_APP_URL ?? 'https://app.repaschallenge.ch';

type AuthRoute = '/confirmation' | '/reset-password';

const NATIVE_AUTH_ROUTES: Record<AuthRoute, string> = {
  '/confirmation': '/confirmation',
  // The institutional site already serves the native recovery flow at this
  // French route. The web app owns the English route below, so each platform
  // returns to the flow it can actually complete.
  '/reset-password': '/reinitialisation',
};

/**
 * The native app keeps its established App/Universal Link host. In a browser,
 * email actions must return to the same HTTPS origin so Supabase can restore
 * the session in that browser.
 */
export function getAuthRedirectUrl(route: AuthRoute): string {
  if (Platform.OS !== 'web') {
    // Confirmation : page Expo sur app.repaschallenge.ch (verifyOtp dans le
    // bundle, sans jsdelivr — souvent bloqué sur les réseaux d'entreprise).
    // www.repaschallenge.ch/confirmation reste un App Link possible, mais le
    // fallback navigateur doit vraiment valider le token.
    if (route === '/confirmation') {
      return `${WEB_APP_URL.replace(/\/$/, '')}/confirmation`;
    }
    return `${NATIVE_APP_URL}${NATIVE_AUTH_ROUTES[route]}`;
  }

  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return `${window.location.origin}${route}`;
  }

  return `${WEB_APP_URL.replace(/\/$/, '')}${route}`;
}
